"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.form.basicInfo': 'Información Básica',
    'tutorial.form.name': 'Nombre del Tutorial',
    'tutorial.form.description': 'Descripción',
    'tutorial.form.introText': 'Texto de Introducción',
    'tutorial.form.active': 'Activo',
    'tutorial.form.steps': 'Pasos de Aprendizaje',
    'tutorial.form.stepsDescription': 'Selecciona los pasos de aprendizaje a incluir en este tutorial.',
    'tutorial.form.noStepsAvailable': 'No hay pasos de aprendizaje disponibles. Crea algunos pasos primero.',
    'tutorial.form.sections': 'Secciones del Tutorial',
    'tutorial.form.addSection': 'Agregar Sección',
    'tutorial.form.sectionsDescription': 'Crea secciones con conocimiento específico y prompts para aprendizaje guiado.',
    'tutorial.form.section': 'Sección',
    'tutorial.form.sectionTitle': 'Título de la Sección',
    'tutorial.form.sectionDescription': 'Descripción de la Sección',
    'tutorial.form.sectionPrompt': 'Prompt de la Sección',
    'tutorial.form.sectionKnowledge': 'Base de Conocimiento',
    'tutorial.form.namePlaceholder': 'Ingrese el nombre del entrenamiento...',
    'tutorial.form.avatar': 'Avatar Líder',
    'tutorial.form.avatarPlaceholder': 'Elija un avatar para este tutorial',
    'tutorial.form.selectAvatar': 'Seleccionar Avatar...',
    'tutorial.form.company': 'Empresa / Asignación',
    'tutorial.form.selectCompany': 'Seleccionar Empresa...',
    'tutorial.form.descriptionPlaceholder': 'Describe brevemente lo que cubre este entrenamiento...',
    'tutorial.form.introTextPlaceholder': 'Escriba un texto de introducción que dé la bienvenida al participante...',
    'tutorial.form.step': 'Paso',
    'tutorial.form.addStep': 'Agregar Paso',
    'tutorial.form.stepName': 'Nombre del Paso',
    'tutorial.form.stepNamePlaceholder': 'Ingrese el nombre del paso',
    'tutorial.form.stepDescription': 'Descripción del Paso',
    'tutorial.form.stepDescriptionPlaceholder': 'Ingrese la descripción del paso (opcional)',
    'tutorial.form.selectStep': 'Seleccionar Paso...',
    'tutorial.form.sectionName': 'Nombre de la Sección',
    'tutorial.form.sectionNamePlaceholder': 'Ingrese el nombre de la sección...',
    'tutorial.form.sectionIntro': 'Introducción de la Sección',
    'tutorial.form.sectionIntroPlaceholder': 'Describe lo que el participante aprenderá en esta sección...',
    'tutorial.form.sectionPromptPlaceholder': 'Proporcione conocimiento o orientación para esta sección...',
    'tutorial.form.addKnowledge': 'Agregar Conocimiento',
    'tutorial.form.selectedKnowledge': 'Conocimiento Seleccionado',
    'tutorial.form.files': 'Captura de Pantalla / Pantalla',
    'tutorial.form.screenshot': 'Captura de Pantalla / Pantalla',
    'tutorial.form.screenshotPlaceholder': 'Seleccionar archivo de captura de pantalla...',
    'tutorial.form.video': 'Video (MP4)',
    'tutorial.form.videoPlaceholder': 'Seleccionar archivo de video...',
    'tutorial.form.screenshotMini': 'Miniatura de captura de pantalla',
    'tutorial.form.screenshotMiniPlaceholder': 'Seleccionar miniatura de captura de pantalla...',
    'tutorial.form.videoMini': 'Miniatura de video',
    'tutorial.form.videoMiniPlaceholder': 'Seleccionar miniatura de video...',
    'tutorial.form.attachments': 'Archivos adjuntos',
    'tutorial.form.addFile': 'Agregar archivo',
    'tutorial.form.sectionFileMiniature': 'Imagen en miniatura',
    'tutorial.form.sectionFileRequired': 'Selecciona un archivo antes de agregarlo.',
    'tutorial.form.source.label': 'Fuente',
    'tutorial.form.source.ai': 'Generado por IA',
    'tutorial.form.source.file': 'Escanear archivo fuente y generar tutorial',
    'tutorial.form.sourceFile.label': 'Archivo Fuente',
    'tutorial.form.sourceFile.placeholder': 'Seleccionar archivo fuente...',
    'tutorial.form.scanPages.label': 'Rango de páginas del índice / tabla de contenidos',
    'tutorial.form.scanSourceFile': 'Escanear el archivo fuente y rellenar el formulario del tutorial',
    'tutorial.form.regenerateFromPdf': 'Regenerar desde el archivo fuente',
    'tutorial.form.regenerateFromPdf.title': '¿Regenerar el tutorial desde el archivo fuente?',
    'tutorial.form.regenerateFromPdf.confirm': 'El contenido del tutorial se volverá a generar desde el archivo fuente y podría reemplazar el contenido existente. ¿Deseas continuar?',
    'tutorial.form.tutorialGoal': 'Objetivo del tutorial',
    'tutorial.form.tutorialGoalPlaceholder': 'Describe lo que el participante debería ser capaz de hacer al completar este tutorial...',
    'tutorial.form.examplePrompts_1': 'Crea un tutorial para principiantes sobre los fundamentos del esquí, con pasos, secciones y tareas pendientes',
    'tutorial.form.examplePrompts_2': 'Reescribe la descripción y el texto de introducción para que coincidan con el objetivo del tutorial',
    'tutorial.form.examplePrompts_3': 'Añade una breve lista de tareas a cada sección de este tutorial',
    'tutorial.form.scanNeedsData': 'Completa al menos el nombre, el objetivo o la descripción (o añade pasos) para que la IA tenga algo que ampliar',
    'tutorial.form.start.title': '¿Cómo quieres empezar?',
    'tutorial.form.start.onboarding.title': 'Creador de cursos con IA',
    'tutorial.form.start.onboarding.description': 'Responde a un breve cuestionario guiado sobre tu curso. La IA dará forma al tutorial según tus respuestas.',
    'tutorial.form.start.onboarding.action': 'Iniciar cuestionario guiado',
    'tutorial.form.start.form.title': 'Tutorial en blanco',
    'tutorial.form.start.form.description': 'Rellena el formulario tú mismo, escanea un archivo de origen o pide ayuda al asistente de IA. Puedes añadir el onboarding más tarde desde la cabecera del formulario.',
    'tutorial.form.start.form.action': 'Abrir formulario',
    'tutorial.form.start.form.how.title': 'Cómo funciona',
    'tutorial.form.start.form.how.step1': 'Ponle un nombre al tutorial, elige una categoría y añade una descripción y un logotipo.',
    'tutorial.form.start.form.how.step1.title': 'Configura el tutorial',
    'tutorial.form.start.form.how.step2': 'Crea pasos y secciones y ordénalos según el recorrido que seguirá el participante.',
    'tutorial.form.start.form.how.step2.title': 'Crea la estructura',
    'tutorial.form.start.form.how.step3': 'Añade contenido y archivos adjuntos, como documentos, imágenes y vídeos.',
    'tutorial.form.start.form.how.step3.title': 'Añade materiales de aprendizaje',
    'tutorial.form.start.form.how.step4': 'Añade tareas para que los participantes las marquen durante el aprendizaje.',
    'tutorial.form.start.form.how.step4.title': 'Añade tareas',
    'tutorial.form.start.how.title': 'Cómo funciona',
    'tutorial.form.start.how.step1': 'Completas un breve cuestionario paso a paso: datos básicos del curso, público, estructura y duración, estilo de enseñanza, materiales, modelo de aprendizaje y certificación.',
    'tutorial.form.start.how.step1.title': 'Responde a unas preguntas',
    'tutorial.form.start.how.step2': 'Tus respuestas se adjuntan al tutorial y se guardan junto con él.',
    'tutorial.form.start.how.step2.title': 'Guarda tus respuestas con el tutorial',
    'tutorial.form.start.how.step3': 'La IA las usa como instrucciones cada vez que genera contenido - en el asistente de IA y al escanear un archivo de origen - para que la estructura, la profundidad, el tono y los ejercicios se ajusten a tus elecciones.',
    'tutorial.form.start.how.step3.title': 'Adapta el contenido a tus preferencias',
    'tutorial.form.assistant': 'Asistente',
    'tutorial.scanned': 'Tutorial escaneado y formulario completado correctamente',
    'tutorial.scanFailed': 'No se pudo escanear el tutorial',
    'tutorial.category.loadFailed': 'No se pudieron cargar las categorías',
    'tutorial.form.expireAt': 'Fecha de caducidad',
    'tutorial.form.scanKnowledge.label': 'O usa una entrada de conocimiento como fuente de escaneo',
    'tutorial.form.scanKnowledge.none': 'Ninguna entrada de conocimiento seleccionada',
    'tutorial.form.source.ai.description': 'El contenido del tutorial será generado por la IA en tiempo real.',
    'tutorial.form.source.file.description': 'Sube un archivo fuente (p. ej. PDF). Se escanea su índice para construir el tutorial.',
    'tutorial.form.scanSourceFile.description.ai': 'La IA analizará los datos ya introducidos y completará la estructura que falta del tutorial (secciones y pasos).',
    'tutorial.form.scanSourceFile.description.file': 'Se escaneará el archivo fuente para generar la estructura completa del tutorial y su contenido (secciones, pasos y textos).',
    'tutorial.form.onboardingAttached': 'Onboarding adjunto',
    'tutorial.form.scanProgress.step': 'Paso',
    'tutorial.form.scanProgress.section': 'Sección',
    'tutorial.form.scanProgress.reading': 'Leyendo el archivo fuente...',
    'tutorial.form.scanProgress.index': 'Analizando la estructura y planificando secciones...',
    'tutorial.form.scanProgress.content': 'Escribiendo el contenido de la sección',
    'tutorial.form.scanProgress.todos': 'Creando tareas',
    'tutorial.form.source_pages': 'Páginas de origen de la sección',
    'tutorial.form.category': 'Categoría',
    'tutorial.form.no_cat': 'Sin categoría',
    'tutorial.form.logo': 'Logo del Tutorial',
    'tutorial.form.todoItems': 'Elementos de Tarea',
    'tutorial.form.todoItemPlaceholder': 'Ingrese elemento de tarea...',
    'tutorial.form.todoDescription': 'Administrar lista de tareas para este tutorial',
    'tutorial.form.addTodoItem': 'Agregar Tarea',
    'tutorial.form.removeTodoItem': 'Eliminar Tarea',
    'tutorial.form.noTodoItems': 'No hay elementos de tarea para este tutorial',
    'tutorial.form.updatedFromAI': 'Formulario actualizado desde el asistente de IA',
    // Onboarding wizard
    'tutorial.form.onboarding.button': 'Onboarding',
    'tutorial.form.onboarding.submit': 'Generar curso',
    'tutorial.form.onboarding.stepLabel': 'Paso',
    'tutorial.form.onboarding.step1': 'Información básica',
    'tutorial.form.onboarding.step2': 'Destinatarios',
    'tutorial.form.onboarding.step3': 'Parámetros del curso',
    'tutorial.form.onboarding.step4': 'Estilo del curso',
    'tutorial.form.onboarding.step5': 'Materiales a generar',
    'tutorial.form.onboarding.step6': 'Multimedia',
    'tutorial.form.onboarding.step7': 'Modelo de aprendizaje',
    'tutorial.form.onboarding.step8': 'Certificación',
    'tutorial.form.onboarding.name': 'Nombre del curso',
    'tutorial.form.onboarding.category': 'Categoría',
    'tutorial.form.onboarding.goals': 'Objetivo del curso',
    'tutorial.form.onboarding.description': 'Descripción del curso (máx. 2000 caracteres)',
    'tutorial.form.onboarding.level': 'Nivel de conocimientos',
    'tutorial.form.onboarding.participants': 'Número de participantes',
    'tutorial.form.onboarding.industries': 'Sector',
    'tutorial.form.onboarding.targetGroups': 'Público objetivo',
    'tutorial.form.onboarding.totalHours': 'Duración total del curso',
    'tutorial.form.onboarding.modulesCount': 'Número de pasos',
    'tutorial.form.onboarding.lessonsPerModule': 'Secciones por paso',
    'tutorial.form.onboarding.lessonMinutes': 'Duración media de la sección',
    'tutorial.form.onboarding.intensity': 'Intensidad',
    'tutorial.form.onboarding.styles': 'Estilo de enseñanza',
    'tutorial.form.onboarding.tone': 'Tono de comunicación',
    'tutorial.form.onboarding.materials': 'La IA debe crear',
    'tutorial.form.onboarding.aiAvatar': 'Avatar de IA',
    'tutorial.form.onboarding.slides': 'Generar diapositivas',
    'tutorial.form.onboarding.narration': 'Generar narración',
    'tutorial.form.onboarding.quizVideo': 'Generar quiz en vídeo',
    'tutorial.form.onboarding.graphics': 'Generar gráficos',
    'tutorial.form.onboarding.graphicsStyle': 'Estilo de gráficos',
    'tutorial.form.onboarding.theoryPracticeRatio': 'Teoría ←→ Práctica',
    'tutorial.form.onboarding.exercisesCount': 'Número de ejercicios',
    'tutorial.form.onboarding.caseStudiesCount': 'Número de casos de estudio',
    'tutorial.form.onboarding.finalProject': 'Proyecto final',
    'tutorial.form.onboarding.finalExam': 'Examen final',
    'tutorial.form.onboarding.certificate': 'Certificado de finalización',
    'tutorial.form.onboarding.passThreshold': 'Nivel de aprobación',
    'tutorial.form.onboarding.numbered': 'Certificado numerado',
    'tutorial.form.onboarding.qrVerification': 'Verificación del certificado por QR',
    'tutorial.form.onboarding.goals.knowledge': 'Adquirir conocimientos',
    'tutorial.form.onboarding.goals.skills': 'Adquirir habilidades',
    'tutorial.form.onboarding.goals.certification': 'Certificación',
    'tutorial.form.onboarding.goals.process_implementation': 'Implantación de un proceso',
    'tutorial.form.onboarding.goals.sales_increase': 'Aumento de ventas',
    'tutorial.form.onboarding.goals.company_automation': 'Automatización de la empresa',
    'tutorial.form.onboarding.goals.career_growth': 'Desarrollo profesional',
    'tutorial.form.onboarding.goals.exam_preparation': 'Preparación para un examen',
    'tutorial.form.onboarding.levels.beginner': 'Principiante',
    'tutorial.form.onboarding.levels.intermediate': 'Intermedio',
    'tutorial.form.onboarding.levels.advanced': 'Avanzado',
    'tutorial.form.onboarding.levels.expert': 'Experto',
    'tutorial.form.onboarding.industries.b2b': 'B2B',
    'tutorial.form.onboarding.industries.ecommerce': 'E-commerce',
    'tutorial.form.onboarding.industries.services': 'Servicios',
    'tutorial.form.onboarding.industries.production': 'Producción',
    'tutorial.form.onboarding.industries.accounting': 'Contabilidad',
    'tutorial.form.onboarding.industries.it': 'TI',
    'tutorial.form.onboarding.industries.education': 'Educación',
    'tutorial.form.onboarding.industries.real_estate': 'Inmobiliaria',
    'tutorial.form.onboarding.industries.medicine': 'Medicina',
    'tutorial.form.onboarding.industries.other': 'Otro',
    'tutorial.form.onboarding.targetGroups.business_owners': 'Propietarios de empresas',
    'tutorial.form.onboarding.targetGroups.ceo': 'CEO',
    'tutorial.form.onboarding.targetGroups.managers': 'Gerentes',
    'tutorial.form.onboarding.targetGroups.sales': 'Comerciales',
    'tutorial.form.onboarding.targetGroups.hr': 'RR. HH.',
    'tutorial.form.onboarding.targetGroups.marketing': 'Marketing',
    'tutorial.form.onboarding.targetGroups.developers': 'Programadores',
    'tutorial.form.onboarding.targetGroups.freelancers': 'Autónomos',
    'tutorial.form.onboarding.targetGroups.employees': 'Empleados',
    'tutorial.form.onboarding.intensities.micro_learning': 'Microaprendizaje',
    'tutorial.form.onboarding.intensities.standard': 'Estándar',
    'tutorial.form.onboarding.intensities.academy': 'Academia',
    'tutorial.form.onboarding.intensities.masterclass': 'Masterclass',
    'tutorial.form.onboarding.styles.expert': 'Experto',
    'tutorial.form.onboarding.styles.business': 'Empresarial',
    'tutorial.form.onboarding.styles.formal': 'Formal',
    'tutorial.form.onboarding.styles.practical': 'Práctico',
    'tutorial.form.onboarding.styles.coaching': 'Coaching',
    'tutorial.form.onboarding.styles.storytelling': 'Storytelling',
    'tutorial.form.onboarding.styles.mentoring': 'Mentoría',
    'tutorial.form.onboarding.styles.workshop': 'Taller',
    'tutorial.form.onboarding.tones.professional': 'Profesional',
    'tutorial.form.onboarding.tones.friendly': 'Cercano',
    'tutorial.form.onboarding.tones.dynamic': 'Dinámico',
    'tutorial.form.onboarding.tones.premium': 'Premium',
    'tutorial.form.onboarding.tones.corporate': 'Corporativo',
    'tutorial.form.onboarding.materials.outline': 'Esquema',
    'tutorial.form.onboarding.materials.full_lessons': 'Contenido completo de las lecciones',
    'tutorial.form.onboarding.materials.presentations': 'Presentaciones',
    'tutorial.form.onboarding.materials.pdf': 'PDF',
    'tutorial.form.onboarding.materials.workbook': 'Cuaderno de ejercicios',
    'tutorial.form.onboarding.materials.checklists': 'Listas de verificación',
    'tutorial.form.onboarding.materials.quizzes': 'Cuestionarios',
    'tutorial.form.onboarding.materials.exams': 'Exámenes',
    'tutorial.form.onboarding.materials.certificate': 'Certificado',
    'tutorial.form.onboarding.materials.practical_tasks': 'Tareas prácticas',
    'tutorial.form.onboarding.materials.worksheets': 'Hojas de trabajo',
    'tutorial.form.onboarding.materials.prompt_pack': 'Prompt Pack',
    'tutorial.form.onboarding.materials.case_study': 'Caso de estudio',
    'tutorial.form.onboarding.materials.landing_page': 'Landing page',
    'tutorial.form.onboarding.materials.sales_webinar': 'Webinar de ventas',
    'tutorial.form.onboarding.materials.email_campaign': 'Campaña de e-mail',
    'tutorial.form.onboarding.materials.social_posts': 'Publicaciones en redes sociales',
    'tutorial.form.onboarding.materials.meta_ads': 'Anuncios en Meta',
    'tutorial.form.onboarding.materials.google_ads': 'Anuncios en Google',
    'tutorial.form.onboarding.imageStyles.photorealistic': 'Fotorrealista',
    'tutorial.form.onboarding.imageStyles.corporate': 'Corporativo',
    'tutorial.form.onboarding.imageStyles.minimalist': 'Minimalista',
    'tutorial.form.onboarding.imageStyles.3d': '3D',
    'tutorial.form.onboarding.imageStyles.infographic': 'Infografías',
    'tutorial.form.onboarding.imageStyles.comic': 'Cómic',
    'tutorial.form.onboarding.imageStyles.premium': 'Premium',
    'tutorial.form.sourcePreview': 'Vista previa de la fuente',
    'tutorial.form.editor.addField': 'Añadir campo',
    'tutorial.form.editor.addOption': 'Añadir opción',
    'tutorial.form.editor.fieldType': 'Tipo de campo',
    'tutorial.form.editor.label': 'Etiqueta',
    'tutorial.form.editor.max': 'Máx.',
    'tutorial.form.editor.min': 'Mín.',
    'tutorial.form.editor.moveDown': 'Mover hacia abajo',
    'tutorial.form.editor.moveUp': 'Mover hacia arriba',
    'tutorial.form.editor.multiple': 'Selección múltiple',
    'tutorial.form.editor.name': 'Nombre',
    'tutorial.form.editor.optionLabel': 'Etiqueta de la opción',
    'tutorial.form.editor.optionValue': 'Valor de la opción',
    'tutorial.form.editor.options': 'Opciones',
    'tutorial.form.editor.placeholder': 'Texto de ejemplo',
    'tutorial.form.editor.remove': 'Eliminar',
    'tutorial.form.editor.required': 'Obligatorio',
    'tutorial.form.editor.rows': 'Filas',
    'tutorial.form.editor.showValue': 'Mostrar valor',
    'tutorial.form.editor.step': 'Paso',
    'tutorial.form.editor.submitLabel': 'Etiqueta del botón de envío',
    'tutorial.form.editor.type': 'Tipo',
    'tutorial.form.editor.unit': 'Unidad',
    'tutorial.form.editor.fieldType.input': 'Campo de texto',
    'tutorial.form.editor.fieldType.textarea': 'Área de texto',
    'tutorial.form.editor.fieldType.select': 'Lista desplegable',
    'tutorial.form.editor.fieldType.radio': 'Botones de opción',
    'tutorial.form.editor.fieldType.checkbox': 'Casilla de verificación',
    'tutorial.form.editor.fieldType.date': 'Fecha',
    'tutorial.form.editor.fieldType.switch': 'Interruptor',
    'tutorial.form.editor.fieldType.slider': 'Control deslizante',
    'tutorial.form.editor.inputFieldType.text': 'Texto',
    'tutorial.form.editor.inputFieldType.number': 'Número',
    'tutorial.form.editor.inputFieldType.email': 'Correo electrónico',
    'tutorial.form.editor.inputFieldType.password': 'Contraseña',
    'tutorial.form.editor.inputFieldType.tel': 'Teléfono',
    'tutorial.form.editor.inputFieldType.url': 'URL',
    'tutorial.form.editor.inputFieldType.search': 'Búsqueda',
    'tutorial.form.editor.inputFieldType.date': 'Fecha',
    'tutorial.form.editor.inputFieldType.datetime-local': 'Fecha y hora',
    'tutorial.form.editor.inputFieldType.time': 'Hora',
    'tutorial.form.editor.defaultSubmitLabel': 'Enviar',
    'tutorial.form.editor.defaultFieldLabel': 'Nuevo campo',
    'tutorial.form.editor.defaultOptionLabel': 'Opción {index}',
    'tutorial.form.editor.formEditor': 'Editor de formulario',
    'tutorial.form.editor.formIncluded': 'Formulario añadido',
    'tutorial.form.editor.saveForm': 'Guardar formulario',
};
